import React from 'react';
import { strings } from '../../resources/strings';
import { DataSource } from '../../enums/DataSource';
import { SeparationType } from '../../enums/SeparationType';
import { StateOrderIdentification } from '../../enums/StateOrderIdentification';
import { StatePrescriptionIdentification } from '../../enums/StatePrescriptionIdentification';
import { GlobalPickerManagementOption } from '../../enums/GlobalPickerManagementOption';
import { StatePrescriptionLog } from '../../models/StatePrescriptionLog';
import { StateLog } from '../../models/StateLog';
import { useOrderUtils } from '../../hooks/useOrderUtils';
import { DropdownButton, DropdownButtonColor } from '../../common-components/DropdownButton/DropdownButton'
import { ModalRecipes } from '../ModalRecipes/ModalRecipes';

interface IGlobalPickerOrderManagementButtonProps {
  orderId?: number;
  orderNumber?: string;
  separationType?: SeparationType;
  orderDataSource?: DataSource;
  orderIsPhysicalStore?: boolean;
  currentState?: StateLog | null;
  currentStatePrescription?: StatePrescriptionLog | null;
  clickItem?: (key: any) => void;
  modalOpened?: () => void;
  modalClosed?: (changed?: boolean) => void;
  statePrescriptionChanged?: (newStateId?: number) => void;
  stateOrderChanged?: (newStateId?: number) => void;
  modalRecipesTitle?: string;
  customerId?: number;
}

export const GlobalPickerOrderManagementButton: React.FC<IGlobalPickerOrderManagementButtonProps> = ({
  orderId,
  orderNumber,
  separationType,
  orderDataSource,
  orderIsPhysicalStore,
  currentState,
  currentStatePrescription,
  clickItem,
  modalOpened,
  modalClosed,
  statePrescriptionChanged,
  stateOrderChanged,
  modalRecipesTitle,
  customerId
}) => {

  const {
    saveNewStatePrescription,
    saveNewStateOrder
  } = useOrderUtils();
  const [modalRecipesVisible, setModalRecipesVisible] = React.useState<boolean>(false);

  if (separationType !== SeparationType.Prescription) return null;

  const options = [
  ];

  const currentStatePrescriptionId = currentStatePrescription?.currentStateId || StatePrescriptionIdentification.SemReceita;

  if (currentStatePrescriptionId === StatePrescriptionIdentification.SemReceita) {
    options.push({
      key: GlobalPickerManagementOption.RegisterRecipe,
      text: `${strings.RegisterRecipe}`
    });
  } else {
    options.push({
      key: GlobalPickerManagementOption.RegisteredRecipes,
      text: `${strings.ChangeRecipeOnlyIfNecessary}`
    });
    if (currentState?.currentStateId === StateOrderIdentification.AguardandoSeparacao) {
      options.push({
        key: GlobalPickerManagementOption.ConfirmSeparation,
        text: `${strings.ConfirmSeparation}`
      });
    }
  }

  return (
    <>
      <DropdownButton
        items={options}
        defaultStyle={true}
        small={true}
        buttonColor={DropdownButtonColor.Success}
        text={''}
        clickItem={(key) => clickItem ? clickItem(key) : handleClickItem(key)}
      />
      <ModalRecipes
        visible={modalRecipesVisible}
        readonly={false}
        close={closeModalRecipes}
        title={modalRecipesTitle || `${strings.Recipes}`}
        orderId={orderId}
        orderNumber={orderNumber}
        orderDataSource={orderDataSource}
        orderIsPhysicalStore={orderIsPhysicalStore || false}
        customerId={customerId}
      />
    </>
  );

  function handleClickItem(key: any) {
    if (!orderId) return;
    if (key === GlobalPickerManagementOption.RegisterRecipe || key === GlobalPickerManagementOption.RegisteredRecipes) {
      setModalRecipesVisible(true);
      if (modalOpened) modalOpened();
      return;
    }
    if (key === GlobalPickerManagementOption.ConfirmSeparation) {
      saveNewStatePrescription(StatePrescriptionIdentification.AguardandoMontagemExterna, orderId);
      return;
    }
  }

  function closeModalRecipes() {
    setModalRecipesVisible(false);
    if (modalClosed) modalClosed(true);
  }

}